/**
 * Formats a string (usually from the locale content) by replacing all $ARG strings,
 * similar to formatting a string in C.
 * @param content
 * @param args
 * @returns
 * @example formatString('$ARG0 from $ARG1', 'Hello', 'World') => 'Hello from World'
 */
const formatString = (content: string, ...args: string[]): string => {
  // locale JSON should have args in form $ARG0, $ARG1 etc...
  if (args?.length) {
    args.forEach((arg, index) => {
      if (arg) {
        content = content.replace(`$ARG${index}`, arg);
      }
    });
  }
  return content || '';
};

export default formatString;
